import { castArray } from 'lodash'

const targetsProduct = (element, event, callback) => {
  castArray(element).forEach(el => {
    if (!el) return

    castArray(event).forEach(e => {
      callback(el, e)
    })
  })
}

const useEventListener = (controller, options = {}) => {
  const defaultOptions = {
    element: controller.element,
    event: null,
    listener: null,
    listenerOptions: false
  }

  const { element, event, listener, listenerOptions } = Object.assign({}, defaultOptions, options)

  const controllerMethod = controller[listener].bind(controller)
  const eventListener = e => controllerMethod(e)

  const observe = () =>
    targetsProduct(element, event, (el, e) => {
      el.addEventListener(e, eventListener, listenerOptions)
    })
  const unobserve = () =>
    targetsProduct(element, event, (el, e) => {
      el.removeEventListener(e, eventListener, listenerOptions)
    })

  const controllerDisconnect = controller.disconnect.bind(controller)
  Object.assign(controller, {
    disconnect() {
      unobserve()
      controllerDisconnect()
    }
  })
  observe()

  return [observe, unobserve]
}

export { useEventListener }
